/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import {
  CropRotate,
  PieChart,
  Settings,
  ViewInAr,
  Code,
  BarChart,
  CloudOutlined,
  FacoritBorder,
  Public,
  PersonOutlined,
  AddLocationAltOutlined,
  PhoneIphone,
  EmailOutlined,
  Facebook,
  Twitter,
  Instagram,
  YouTube,
  FaxOutlined,
  HouseSidingOutlined,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { MdEmail, MdLocalPhone } from "react-icons/md";

export const nav = [
  // {
  //   text: "Home",
  //   path: "/",
  // },

  {
    text: "Services",
    path: "/services",
  },
  {
    text: "About",
    path: "/about",
  },
  {
    text: "Partners",
    path: "/partnership",
  },
  {
    text: "News",
    path: "/blog",
  },
  // {
  //   text: "Tender",
  //   path: "/tenders",
  // },
  {
    text: "Contact",
    path: "/contact",
  },
  {
    text: "IT",
    path: "/IT_Service",
  },
   {
    text: "Motors",
    path: "/motors",
  },
  {
    // text: "Admin",
    path: "/admin/dashboard",
  },
  
];

export const home = [
  {
    text: <i>Lada Vesta</i>,
    title: "Bazra Motors",
    cover: process.env.PUBLIC_URL + "../hero/banner1.jpg",
  },

  {
    text:<i>Urban Development</i>,
    title: "Bazra Motors",
    cover: process.env.PUBLIC_URL + "../hero/realstate.jpeg",
  },

  {
    text: <i>max-vygoda-up</i>,
    title: "Bazra Motors",
    cover: process.env.PUBLIC_URL + "../hero/LastNews.jpg",
  },
  {
    text:<i>Urban Development</i>,
    title: "Bazra Motors",
    cover: process.env.PUBLIC_URL + "../hero/reslstate1.jpeg",
  },
  {
    text: <i>Lada Niva car</i>,
    title: "Bazra Motors",
    cover: "../hero/banner3.jpg",
  },
  {
    text: <i> Lada pres-releas</i>,
    title: "Bazra Motors",
    cover: process.env.PUBLIC_URL + "../hero/pres-releas.jpg",
  },
  {
    text: <i>Lada Niva car</i>,
    title: "Bazra Motors",
    cover: process.env.PUBLIC_URL + "../hero/main_desktop.webp",
  },

  {
    text: <i>lada raven supercar</i>,
    title: "Bazra Motors",
    cover:
      process.env.PUBLIC_URL +
      "../hero/2015_lada_raven_supercar_concept-HD.jpg",
  },

  {
    text: <i>Lada-Crossover-Models</i>,
    title: "Bazra Motors",
    cover: process.env.PUBLIC_URL + "../hero/Lada-Crossover-Models.jpg",
  },
  {
    text: "Lada-Niva-Bronto Car",
    title: "Bazra Motors",
    cover: "../hero/Lada-Niva-Bronto-Video-main.jpg",
  },
  {
    text: <i>Lada-x-cross-5</i>,
    title: "Bazra Motors",
    cover: "../hero/lada-x-cross-5-1.jpg",
  },
];

export const about = [
  {
    text: "About us Bazra",
    visionDesc: (
      <p>
        Leading the future through connecting businesses and individuals to vital knowledge technology products is our vision!
      </p>
    ),
    objectiveDesc: (
      <p>
        Working for the safest and most responsible living, working and moving is our objective.
      </p>
    ),
    missionDesc: (
      <p>
        Building corporate economy of the group is our mission
      </p>
    ),
    goalDesc: (
      <p>
        Our goal is to engaging talent, innovate and serve the highest quality in a better way.     
         </p>
    ),
    cover: "../IMGlogo1.jpg",
    title: "10 + years of exprince in the Manufacturing  industry",
    moreDesc:
      "We; BAZRA INVESTMENT GROUP, are a group of companies doing business in areas of trading, Import-Export, construction, investment management, IT, motor engineering and urban development. BIG brings world class advice, know-how, technology and finance to Ethiopia through the use of local talent and via collaboration with international partners. BAZRA is working in partnership with world-renowned companies to assemble vehicles such as LADA, BAW and BAIC. BAZRA represent VW/FAW and KAMAZ in Ethiopia; plus, it also represents Belarus Tractors, Kirovets Tractors, VIM Tractors and attachments, and KLEVER attachments, this has allowed BAZRA to provide the best automotive and agricultural machinery products and services at the highest standards with international certification making it a world-class company operating in the African continent.",
    bannerDesc:
      "We; BAZRA INVESTMENT GROUP (BIG), are a group of companies doing business in areas of IT, motor engineering, investment management, pharmaceutical and biopharmaceuticals and urban development. BIG brings world class advice, know-how, technology and finance to Ethiopia through the use of local talent and via collaboration with international partners. BAZRA is working in partnership with world-renowned companies to assemble vehicles such as LADA, BAW and BAIC. BAZRA represent VW/FAW, KAMAZ and MAZ in Ethiopia; BAZRA INVESTMENT GROUP builds on the premise of mutual trust and respect; is working towards the development of a Biopharmaceuticals industry, an automotive assembly and IT park in Ethiopia. ",
  },
];

export const overview = [
  {
    id: 1,
    title: "Exprience",
    Desc: "BAZRA is an Ethiopian owned company with 10+ years of experience in vehicle assembly, manufacturing and services. ",
    cover: "../icon1.png",
  },
  {
    id: 2,
    icon: <Settings />,
    title: "Founder",
    Desc: "The company has been found by industry specialists, technologists and professionals.",
    cover: "../icon2.png",
  },
  {
    id: 3,
    icon: <Settings />,
    title: "Service",
    Desc: "Provide End to End Services in number of areas of specialization to meet customer requirements.",
    cover: "../icon3.png",
  },

  {
    id: 4,
    icon: <Settings />,
    title: "Employee",
    Desc: "100+ Employees, Certified and Committed to Best Practices",
    cover: "../icon4.png",
  },
  {
    id: 5,
    icon: <Settings />,
    title: "Revenu",
    Desc: "Annual Revenue of '10M+' many ETB ",
    cover: "../icon5.png",
  },
  {
    id: 6,
    icon: <CropRotate />,
    title: "Leading Player",
    Desc: "BAZRA is a Leading Player in Automotive Assembly and Manufacturing Market with Many other manufacturing projects completed and underway.",
    cover: "../icon6.png",
  },
];

export const service = [
  {
    id: 1,
    icon: <Settings />,
    title: "Manufacturing ",
    Desc: "Bazra Investment Group Manufacturing ",
    cover: "../bz1.png",
  },
  {
    id: 2,
    icon: <CropRotate />,
    title: "Transport",
    Desc: "Bazra Investment Group Transport",
    cover: "../bz1.png",
  },
  {
    id: 3,
    icon: <ViewInAr />,
    title: "Motor Vihecle Part",
    Desc: "Bazra Investment Group  Vihecle Part",
    cover: "../bz1.png",
  },
  {
    id: 4,
    icon: <PieChart />,
    title: "Import-Export",
    Desc: "Bazra Investment Group  Import-Export",
    cover: "../bz1.png",
  },
  {
    id: 5,
    icon: <Code />,
    title: "Motor Engineering",
    Desc: "Bazra Investment Group  Motor Engineering",
    cover: "../bz1.png",
  },
  {
    id: 6,
    icon: <BarChart />,
    title: "Agriculture",
    Desc: "Bazra Investment Group Agriculture",
    cover: "../bz1.png",
  },
  {
    id: 7,
    icon: <BarChart />,
    title: "Urban-Development",
    Desc: "Bazra Investment Group UrbanDevelopment",
    cover: "../bz1.png",
  },
  {
    id: 8,
    icon: <BarChart />,
    title: "Logistics",
    Desc: "Bazra Investment Group Logistics",
    cover: "../bz1.png",
  },
];

export const Banservice = [
  {
    id: 1,
    icon: <Settings />,
    title: "",
    Desc: "Bazra Investment Group description in this About us Bazra Investment Group plc",
    cover: "../service12.png",
  },
];

export const counter = [
  {
    id: 0,
    icon: <CloudOutlined />,
    num: 900,
    title: "Happy Client",
    Desc: "Bazra Motors description in this About us Bazra Investment Group plc",
    cover: "../bz1.png",
  },
  {
    id: 1,
    icon: <CropRotate />,
    num: 900,
    title: "Lada Cars",
    Desc: "Bazra Motors description in this About us Bazra Investment Group plc",
    cover: "../bz1.png",
  },
  {
    id: 2,
    icon: <ViewInAr />,
    num: 900,
    title: "Employee",
    Desc: "Bazra Motors description in this About us Bazra Investment Group plc",
    cover: "../bz1.png",
  },
  {
    id: 3,
    icon: <PieChart />,
    num: 100,
    title: "Sister Company",
    Desc: "Bazra Motors description in this About us Bazra Investment Group plc",
    cover: "../bz1.png",
  },
];

export const hero = [
  "../images/list/p-1.png",
  "../images/list/p-2.png",
  {
    Image: "../images/list/p-2.png",
  },
];

export const portfolio = [
  {
    category: "Vesta",
    items: [
      {
        name: "Lada vasta",
        title: "Car Model 2",
        cover: "../portfolio/vesta/techno_672.webp",
      },
      // { name: "Lada-Niva-Bronto-8", title: "Car Mode3 ", cover: "../portfolio/vesta/spec.PNG" },
      {
        name: "Vasta Lada",
        title: "Car Model 4",
        cover: "../portfolio/vesta/techno_221.webp",
      },
      {
        name: "pres-releas",
        title: "Car Model 5",
        cover: "../portfolio/vesta/profile_2.webp",
      },

      // { name: "LADA 4x4", title: "Car Model 1", cover: "../portfolio/vesta/vs_main_header_d.webp" },
      {
        name: "Lada vasta",
        title: "Car Model 2",
        cover: "../portfolio/vesta/techno_691.webp",
      },
      // { name: "Lada-Niva-Bronto-8", title: "Car Mode3 ", cover: "../hero/Lada-Niva-Bronto-8.jpg" },
      {
        name: "Vasta Lada",
        title: "Car Model 4",
        cover: "../portfolio/vesta/techno_221.webp",
      },
      {
        name: "pres-releas",
        title: "Car Model 5",
        cover: "../portfolio/vesta/profile_1.webp",
      },
      // { name: "vaz-black-lada-car", title: "Car Model 6", cover: "../hero/HD-wallpaper-vaz-black-lada-car.jpg" },
    ],
  },
  {
    category: "Granta",
    items: [
      {
        name: "LADA Granta classic",
        title: "Manifa Model",
        cover: "../portfolio/Granta/classic_22_221.webp",
      },
      {
        name: "Granta-lada-car",
        title: "Car Model 6",
        cover: "../portfolio/Granta/club_195.png",
      },
      {
        name: "LADA Granta classic",
        title: "Manifa Model",
        cover: "../portfolio/Granta/classic_22_672.webp",
      },
      {
        name: "LADA Granta classic",
        title: "Manifa Model",
        cover: "../portfolio/Granta/luxe_691.png",
      },
      {
        name: "LADA Granta classic",
        title: "Manifa Model",
        cover: "../portfolio/Granta/luxe_691.png",
      },
    ],
  },
  {
    category: "Lada4X4",
    items: [
      { name: "LADA 4x4", title: "Car Model 1", cover: "../portfolio/4x4.png" },
    ],
  },
  // Add more portfolio items as needed
];

export const contact = [
  {
    icon: (
      <i>
        <AddLocationAltOutlined />
        <a title="map"
          href="https://maps.google.com?q=Friendship+Business+Center,+Airport+Rd,+Addis"
          target="_blank"
          rel="noopener noreferrer"
        ></a>
      </i>
    ),
    text: (
      <i>
        <a
          href="https://maps.google.com?q=Friendship+Business+Center,+Airport+Rd,+Addis"
          target="_blank"
          rel="noopener noreferrer"
        >
          Friendship Building, Africa Avenue
        </a>
      </i>
    ),
  },
  {
    icon: (
      <a>
        <MdLocalPhone />
        <a title="phone"
          href="https://wa.me/+ 251 116151212?"
          target="_blank"
          rel="noopener noreferrer"
        ></a>
      </a>
    ),
    text: (
      <a>
        <a
          href="https://wa.me/+251116151212?"
          target="_blank"
          rel="noopener noreferrer"
        >
          + 251 116151212
        </a>
      </a>
    ),
  },
  {
    icon: (
      <a>
        <MdEmail />
        <a title="mail"
          href="mailto:bazrainvestmentgroup@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        ></a>
      </a>
    ),
    text: (
      <a href="mailto:bazrainvestmentgroup@gmail.com/" target="_blank" rel="noreferrer" className="whitespace-normal overflow-ellipsis">
        bazrainvestmentgroup@gmail.com
      </a>

    ),
  },
];

export const bancontact = [
  {
    icon: <AddLocationAltOutlined />,
    text: " addis ababa frindship buliding ",
    cover: "../contactBACK.png",
  },
];

const defaultDescription =
  "Navigating the Business Landscape Strategies for Success Explore the dynamic world of business with Bazra's latest blog post. Gain insights into effective strategies, industry trends, and success stories that inspire and empower entrepreneurs Innovation Unleashed: The Heartbeat of Bazra At the core of Bazra's identity lies innovation. Dive into our exploration of cutting-edge technologies, groundbreaking solutions, and the creative minds behind our most innovative projects.Employee Spotlight: Faces Behind Bazra's Success Meet the exceptional individuals contributing to Bazra's success. Our Employee Spotlight series highlights the talented and dedicated professionals making Bazra a vibrant and collaborative workplace.Sustainable Practices: Building a Better Tomorrow Sustainability is not just a buzzword at Bazra; it's a commitment. Explore our sustainable practices and initiatives aimed at making a positive impact on the environment and future generations.";

export const postData = [
  {
    id: 1,
    img: "../../../lada.jpeg",
    ttl: "TITLE 1",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    id: 2,
    img: "../../../lada0.jpeg",
    ttl: "TITLE 2",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    id: 3,
    ttl: "TITLE 3",
    mln: 13,
    dsc: defaultDescription,
  },
  {
    id: 4,
    img: "../../../lada1.jpeg",
    ttl: "TITLE 4",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    id: 5,
    img: "../../../lada2.jpeg",
    ttl: "TITLE 5",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    id: 6,
    img: "../../../lada3.jpeg",
    ttl: "TITLE 6",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    id: 7,
    img: "../../../lada.jpeg",
    ttl: "TITLE 7",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    id: 8,
    ttl: "TITLE",
    mln: 13,
    dsc: defaultDescription,
  },
  {
    id: 9,
    img: "../../../lada.jpeg",
    ttl: "TITLE 8",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    id: 10,
    img: "../../../lada.jpeg",
    ttl: "TITLE 9",
    dsc: defaultDescription,
    mln: 3,
  },
  {
    mln: 13,
    dsc: defaultDescription,
  },
];

export const list = [
  {
    id: 1,
    cover: "../lada.JPEG",
    name: "LADA 4x4",
    location: "Adiss Ababa",
    category: "For Rent",
    price: "Birr 3,700",
    type: "",
  },
  {
    id: 2,
    cover: "../lada.JPEG",
    name: "Lada Vesta",
    location: "Addiss ababa",
    category: "For Sale",
    price: "Birr 9,750",
    type: "",
  },
  {
    id: 3,
    cover: "../lada.JPEG",
    name: "car",
    location: "Addis Ababa",
    category: "For Rent",
    price: "Birr 5,860",
    type: "logistics",
  },
  {
    id: 4,
    cover: "../lada.JPEG",
    name: "Lada Vesta",
    location: "Addiss ababa",
    category: "For Sale",
    price: "Birr 9,750",
    type: "",
  },
];

export const footer = [
  {
    title: "",
    text: [
      {
        list: (
          <Link to="/">
            <a href="/">
              <b>Home</b>
            </a>
          </Link>
        ),
      },
      {
        list: (
          <Link to="/services">
            {" "}
            <a href="/services">
              <b>Service</b>
            </a>
          </Link>
        ),
      },
      {
        list: (
          <Link to="/about">
            {" "}
            <a href="/about">
              <b>About Us</b>
            </a>
          </Link>
        ),
      },
      {
        list: (
          <Link to="/blog">
            <a href="/blog">
              <b>News</b>
            </a>
          </Link>
        ),
      },
      {
        list: (
          <Link to="/tenders">
            <a href="/tenders">
              <b>Tenders</b>
            </a>
          </Link>
        ),
      },
      {
        list: (
          <Link to="/contact">
            <a href="/contact">
              <b>Contacts</b>
            </a>
          </Link>
        ),
      },
    ],
  },

  {

    title: "Social",
    text: [
      {
        list: (

          <a>
            <i>
              <EmailOutlined />
            </i>
            <a href="mailto:bazrainvestmentgroup@gmail.com/" target="_blank" rel="noreferrer">
              
              Email
            </a>
          </a>
        ),
      },
      {
        list: (
          <a>
            <i>
              <Facebook />
            </i>{" "}
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer">
              Facebook
            </a>{" "}
          </a>
        ),
      },
     
      {
        list: (
          <a>
            <i>
              <Instagram />
            </i>{" "}
            <a href="https://www.instagram.com" target="_blank" rel="noreferrer">
              Instagram
            </a>{" "}
          </a>
        ),
      },
      {
        list: (
          <a>
            <i>
              <FontAwesomeIcon icon={faXTwitter} />
            </i>
            <a href="https://www.twitter.com" target="_blank" rel="noreferrer">
            <span>Twitter</span>
            </a>
          </a>
        ),
      },
      {
        list: (
          <a>
            <i>
              <FontAwesomeIcon icon={faLinkedin} />
            </i>{" "}
            <a
              href="https://www.linkedin.com/in/"
              target="_blank" rel="noreferrer"
            >
            <span>Linkedin </span>

            </a>
          </a>
        ),
      },
    ],
  },
  {
    title: "Location",
    text: [
      {
        list: (
          <a
            href="https://maps.google.com?q=Friendship+Business+Center,+Airport+Rd,+Addis"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i><AddLocationAltOutlined /></i>
            <span>
              <b>Location: </b>Friendship Building, Africa Avenue
            </span>
          </a>
        ),
      
      },
      {
        list: (
          <a>
           <i><Public /></i> 
            <span>
              <b>Office No: </b>506, Fifth Floor
            </span>
          </a>
        ),
      },
      {
        list: (
          <a>
            <i><HouseSidingOutlined /></i>
            <span>
              <b>House No: </b>5597/506, Worda 2, Sub-City Bole
            </span>
          </a>
        ),
      },
    ],
  },
  {
    title: "Call Us",
    text: [
      {
        list: (
          <a>
            <i><PhoneIphone /></i>
            <span>
              <b>Mob: </b>+ 251 911239976 / + 251 911762127
            </span>
          </a>
        ),
      },
      {
        list: (
          <a>
            <i><PhoneIphone /></i>
            <span>
              <b>Tel: </b>+ 251 116151212
            </span>
          </a>
        ),
      },
      {
        list: (
          <a>
            <i><FaxOutlined /></i>
            <span>
              <b>Fax: </b>+251 116151221
            </span>
          </a>
        ),
      },
    ],
  },
];



export const testimonials = [
  {
    prof: "CORPORATE GOVERNANCE  ",
    cover: "../testimoni.png",
    text: "BAZRA’s corporate governance philosophy will endeavour to exceed regulatory and legal requirements by adopting several voluntary practices aimed at a high level of business ethics, effective supervision, and enhancement of value for all stakeholders.",
    // address: "Addis Ababa",
    name: "",
    icon: [
      <a
        href="mailto:bazrainvestmentgroup@gmail.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fab fa-google"></i>
      </a>,
      <a
        href="https://www.facebook.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-facebook-f"></i>
      </a>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  {
    prof: "BAZRA TEAM",
    cover: "../testimoni.png",
    text: "BAZRA has an internationally skilled professional executive management team with a broad suite of professional expertise, experience and skills. ",
    name: "",
    icon: [
      <i class="fa-brands fa-facebook-f"></i>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  {
    prof: "Client",
    cover: "../testimoni.png",
    text: "good for all in bazra",
    name: "",
    icon: [
      <i class="fa-brands fa-facebook-f"></i>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  
];

export const blog = [
  {
    title: "For New Car",
    cover: "../lada.JPEG",
    Desc: "Manufacturing of motor vehicles, accessories, spare parts and trailers Addis Ababa, Ethiopia",
    author: "Dr. Yayehyirad Asnake",
    date: <i> Date :2016:03:03</i>,
    icon: [
      <a
        href="mailto:bazrainvestmentgroup@gmail.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="fab fa-google"></i>
      </a>,
      <a
        href="https://www.facebook.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i className="fab fa-facebook-f"></i>
      </a>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  {
    title: "For New Car",
    cover: "../lada0.JPEG",
    Desc: "Manufacturing of motor vehicles, accessories, spare parts and trailers Addis Ababa, Ethiopia",
    author: "lealem",
    date: "10",
    icon: [
      <i class="fa-brands fa-facebook-f"></i>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  {
    title: "For New Car",
    cover: "../lada1.JPEG",
    Desc: "Manufacturing of motor vehicles, accessories, spare parts and trailersAddis Ababa, Ethiopia",
    author: "Dr. Yayehyirad Asnake",
    date: "10",
    icon: [
      <i class="fa-brands fa-facebook-f"></i>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  {
    title: "For New Car",
    cover: "../lada2.JPEG",
    Desc: "Manufacturing of motor vehicles, accessories, spare parts and trailers Addis Ababa, Ethiopia",
    author: "Dr. Yayehyirad Asnake",
    date: "10",
    icon: [
      <i class="fa-brands fa-facebook-f"></i>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  {
    title: "For New Car",
    cover: "../lada2.JPEG",
    Desc: "Manufacturing of motor vehicles, accessories, spare parts and trailers Addis Ababa, Ethiopia",
    author: "Dr. Yayehyirad Asnake",
    date: "10",
    icon: [
      <i class="fa-brands fa-facebook-f"></i>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
  {
    title: "For New Car",
    cover: "../lada1.JPEG",
    Desc: "Manufacturing of motor vehicles, accessories, spare parts and trailersAddis Ababa, Ethiopia",
    author: "Fuad",
    date: "10",
    icon: [
      <i class="fa-brands fa-facebook-f"></i>,
      <i class="fa-brands fa-linkedin"></i>,
      <i class="fa-brands fa-twitter"></i>,
      <i class="fa-brands fa-instagram"></i>,
    ],
  },
];

export const serviceData = [
  {
    id: 1,
    icon: <Settings />,

    title: "Manufacturing ",
    imageUrl: "../../../manif.jpg",
    description:
      "BAZRA has a motor engineering company dedicated to automotive assembly and manufacturing as well as biopharmaceuticals and pharmaceuticals manufacturing wing.  BAZRA INVESTMENT GROUP is partnering with scientists, scientific institutions and industry specialists to manufacture Blood Products, Enzymes, Hormones including Human Insulin, both Human and Animal Antibiotics and Vaccines.",
    websiteLink: "/contactpage",
  },
  {
    id: 2,
    icon: <Settings />,

    title: "Transport",
    imageUrl: "../../../serviceD/transprt.webp",
    description:
      "BAZRA MOTORS is working to organize urban taxi service providing companies in partnership and collaboration with the Addis Ababa City Transport Bureau and the Ethiopian Transport Employers Federation based on locally assembled Russian made eco-vehicles for Addis Ababa and other major Ethiopian cities.",
    websiteLink: "/contactpage",
  },
  {
    id: 3,
    icon: <Settings />,

    title: "Motor vihecle Part ",
    imageUrl: "../../../serviceD/vichle part.jpg",

    description:
      "BAZRA provides vehicles as well as spare parts for the vehicles it assembles and represents.",
    websiteLink: "/contactpage",
  },
  {
    id: 4,
    icon: <Settings />,

    title: "Import-Export",
    imageUrl: "../../../serviceD/import-and-export.jpg",

    description:
      "We are an international Business and Trading Company who are working with different kinds of products which are sold for commerce, business or government purposes. To this end we work with big names in the world of international commodity business and trade from food staff to household appliances and furniture to iron ore and steel. We; BAZRA, are a boutique business, trading, products sourcing, Import-Export company. BAZRA plays in commodities of all kind that are of crucial role in the development of economy. BAZRA is there in sourcing all kind of commodities from both Ethiopia to the world and from any point in the globe to any other destination.",
    websiteLink: "/contactpage",
  },
  {
    id: 5,
    icon: <Settings />,

    title: "Motor Engineering",
    imageUrl: "../../../serviceD/Motor Engineering.jpg",

    description:
      "BAZRA is one of Automotive Assemblers and Distributors in Ethiopia, covering passenger cars and medium duty commercial vehicles and agricultural machineries. BAZRA MOTORS has an assembly facility in Kombolcha, 300kms away from Addis Ababa agreed to assemble vehicles.",
    websiteLink: "/contactpage",
  },
  {
    id: 6,
    icon: <Settings />,

    title: "Agriculture",
    imageUrl: "../../../serviceD/Agriculture.jpg",

    description:
      "BAZRA represent quite very bigger names in the world agricultural machinery and technology such as Belarus Tractors, Kirovets Tractors, VIM Tractors and implements, KLEVER implements and GEOMIR (AgroHistory) agricultural IT systems.",
    websiteLink: "/contactpage",
  },
  {
    id: 7,
    icon: <Settings />,

    title: "Urban-Development",
    imageUrl: "../../../serviceD/urban.png",

    description:
      "BAZRA has an urban development wing working to develop cities in Ethiopia with the main focus in Addis Ababa, Arba-Minch, Bahir-Dar, Dessie and Kombolcha. The urban development concepts are multiplied with the concepts of eco-SMART and TECHNOPOLIS ",
    websiteLink: "/contactpage",
  },
  {
    id: 8,
    icon: <Settings />,

    title: "Logistics",
    imageUrl: "../../../serviceD/logistics.jpg",

    description:
      "BAZRA has developed a Logistics and Transport platform which is completely automated system that outperforms the industry's conventional management systems and enables businesses and truck owners to take full control of their assets, cargo and engage actively in the business. The platform provides market, tracing and tracking tools, transport administration and management.",
    websiteLink: "/contactpage",
  },
  {
    id: 8,
    icon: <Settings />,

    title: "Pharmaceuticals and Biopharmaceuticals",
    imageUrl: "../../../serviceD/pharamaceutical.jpg",

    description:
      "BAZRA GROUP is partnering with scientists, scientific institutions and industry specialists to manufacture Blood Products, Enzymes, Hormones including Human Insulin, both Human and Animal Antibiotics and Vaccines.",
    websiteLink: "/contactpage",
  },
    {
    id: 9,
    icon: <Settings />,

    title: "Industries",
    imageUrl: "../../../serviceD/pharamaceutical.jpg",

    description:
      "Our company is characterized by its straight forward approach to some of the world’s most complex business challenges. Working with leading organizations, governments and commercial bodies, our role is to unlock potential for growth through innovation, and create long-term, sustainable impact.",
  },
  {
    id: 10,
    icon: <Settings />,

    title: "Financial Services",
    imageUrl: "../../../serviceD/pharamaceutical.jpg",

    description:
      "BAZRA has a construction wing working in the steadily expanding construction sector; which is a grade I construction company that works hard to advance the civil construction industry.",
  },
  {
    id: 11,
    icon: <Settings />,

    title: "Financial Services",
    imageUrl: "../../../serviceD/pharamaceutical.jpg",

    description:
      "BAZRA INVESTMENT GROUP is soon launching a financial services platform which covers mobile wallet, local and international remittance; and financial mediation which allow us to deliver world class service.",
  },
];

export const Map = [
  {
    text: [
      {
        list: (
          <a>
            <a
              href="https://maps.google.com?q=Friendship+Business+Center,+Airport+Rd,+Addis"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b>
                <i>
                  <AddLocationAltOutlined />{" "}
                </i>
                Location
              </b>{" "}
              Friendship Business Center, Airport Rd, Ethiopia
            </a>
          </a>
        ),
      },
    ],
  },
];

export const products = [
  {
    title: "IT",
    link: "/products/aggregates",
    image: "../../../IT.png",
    description:
      "BAZRA’s IT wing is working both on its own capacity and with international partners in the world of IT. BAZRA is partnering with such big names in the industry as ALT4, FORTECOM, GEOMIR, INFOWATCH, iPavlov, KASPERSKY, Kontur, MPP LABS, SAP LEONARDO, SODA – SYSTEMS INTEGRATION & DATA ANALYTICS, SOFTLINE SOFTCLUB, SOFTLOGIC, VOLTAH. BAZRA has developed its own logistics management and payment platforms.",
  },
  {
    title: "Manufacturing",
    link: "/products/aggregates",
    image: "../../../manif.jpg",
    description:
      "BAZRA has a motor engineering company dedicated to automotive assembly and manufacturing as well as biopharmaceuticals and pharmaceuticals manufacturing wing.  BAZRA INVESTMENT GROUP is partnering with scientists, scientific institutions and industry specialists to manufacture Blood Products, Enzymes, Hormones including Human Insulin, both Human and Animal Antibiotics and Vaccines.",
  },
  {
    title: "Motor Engineering",
    link: "/products/aggregates",
    image: "../../../lada3.jpeg",
    description:
      "BAZRA is one of Automotive Distributors and Manufacturers in Ethiopia, covering passenger cars and medium duty commercial vehicles and agricultural machineries. BAZRA MOTORS has an assembly facility in Kombolcha, 300kms away from Addis Ababa agreed to assemble vehicles.",
  },
  {
    title: "Construction",
    link: "/products/aggregates",
    image: "../../../lada.jpeg",

    description:
      "BAZRA has a construction wing working in the steadily expanding construction sector; which is a grade I construction company that works hard to advance the civil construction industry.",
  },
  {
    title: "Urban Development ",
    link: "/products/aggregates",
    image: "../../../lada0.jpeg",

    description:
      "BAZRA has an urban development wing working to develop cities in Ethiopia with the main focus in Addis Ababa, Arba-Minch, Bahir-Dar, Debre-Birhan, Dessie and Gonder. The urban development concepts are multiplied with the concepts of eco-SMART and TECHNOPOLIS.",
  },


  // Add more product objects similarly
];

export const images = [
  { src: '../../../gallary/2015_lada_raven_supercar_concept-HD.jpg', name: 'lada', role: 'demicar' },
  { src: '../../../gallary/vesta3.jpg', name: 'lada', role: 'vesta' },
  { src: '../../../gallary/main_desktop.webp', name: 'lada', role: 'niva' },
  { src: '../../../gallary/6867247746a5b4ec0c5ec3994a1dc153.jpg', name: 'lada', role: 'Demicar' },
  { src: '../../../gallary/gs_dt.webp', name: 'lada', role: 'granta' },
  { src: '../../../gallary/Lada_Vision014.jpg', name: 'lada', role: '4x4' },
  { src: '../../../gallary/lada-vesta-sw-cross-2023-2024-1692357645.7809312.jpg', name: 'lada', role: 'vesta' },
  { src: '../../../gallary/vs_main_header_d.webp', name: 'lada', role: 'Vesta' },
  { src: '../../../gallary/vaz_catalogue_notes-file_-115365-840.jpg', name: 'lada', role: '4x4' },

  { src: '../../../gallary/classic_22_672.webp', name: 'lada', role: 'granta' },

];

export const partner = [
    {
    category: "Local Partners",
    images: "../partnership/financelogo.png",
    description: "BAZRA has strategic partnerships with local governmental and non-governmental institutions in Ethiopia.",
    partners: [
      {
        "image_src": "../partnership/AA.JPEG",
        description:"Addis Ababa City Administration is one of the strategic partners of BAZRA. Addis Ababa City, BAZRA and the Ethiopian Transport Employers Federation are working in collaboration and partnership to modernize the passenger fleet of the city through supply of eco friendly and modern vehicles."
      },
      {
        "image_src": "../partnership/ANRS.jpeg",
        description:" Amhara National Regional State of EthiopiaAmhara Region is one of the nine regions of Ethiopia with a thirty million people and a third of the national Economy. The regional administration is a strategic partner of BAZRA INVESTMENT GROUP."
      },
      {
        "image_src": "../partnership/Dessie.jpeg",
        description:"BAZRA INVESTMENT GROUP is partner of Dessie City for the urban development of the city with concepts concepts of eco-SMART and TECHNOPOLIS"
      },
      {
        "image_src": "../partnership/ArbaMinch.jpeg",
        description:"BAZRA INVESTMENT GROUP is partner of Arba-Minch City for the urban development of the city with concepts concepts of eco-SMART and TECHNOPOLIS"
      },
      {
        "image_src": "../partnership/kombolcha.jpeg",
        description:"BAZRA INVESTMENT GROUP is partner of Kombolcha City for the urban development of the city with concepts concepts of eco-SMART and TECHNOPOLIS"
      },
      {
        "image_src": "../partnership/awash.png",
        description:"Awash Bank is the strategic partner of BAZRA in the Ethiopian financial sector."
      },
      // {
      //   "image_src": "../partnership/IT/softline.png",
      //   description:"Softline is an international IT solutions provider that offers a wide range of services, including software licensing, cloud solutions, and IT consulting."
      // },
      // {
      //   "image_src": "../partnership/IT/gs.png",
      //   description:"GS is a leading provider of IT solutions and services, specializing in software development and system integration."
      // },
      

    ]
  },
  {
    category: "Technology (IT)",
    images: "../partnership/financelogo.png",
    partners: [
      {
        "image_src": "../partnership/IT/fortecom.png",
        description:" description"
      },
      {
        "image_src": "../partnership/IT/kaspersky.png"
      },
      {
        "image_src": "../partnership/IT/softclub.png"
      },
      {
        "image_src": "../partnership/IT/mpplabs.jpg"
      },
      {
        "image_src": "../partnership/IT/sap.jpg"
      },
      {
        "image_src": "../partnership/IT/softline.png"
      },
      {
        "image_src": "../partnership/IT/gs.png"
      },
      

    ]
  },
  {
    category: "Automotive and Agricultural ",
    images: "../partnership/university.png",
    partners: [
      {
        "image_src": "../partnership/autoagri/avtovaz.JPG"
      },
      {
        "image_src": "../partnership/autoagri/baic.png"
      },
      {
        "image_src": "../partnership/autoagri/baw.png"
      },
      {
        "image_src": "../partnership/autoagri/belarus.png"
      },
      {
        "image_src": "../partnership/autoagri/faw.png"
      },
      {
        "image_src": "../partnership/autoagri/kamaz.png"
      },
      {
        "image_src": "../partnership/autoagri/kirovets.png"
      },
      {
        "image_src": "../partnership/autoagri/klever.png"
      },
      // {
      //   "image_src": "../partnership/autoagri/uaz.png"
      // },
     

    ]
  },
  {
    category: "Chemicals and Fertilizers",
    images: "../partnership/university.png",
    partners: [
      {
        "image_src": "../partnership/chemica&feltrizer/keystone.png"
      },
      {
        "image_src": "../partnership/chemica&feltrizer/tralexcargo.png"
      },
      {
        "image_src": "../partnership/chemica&feltrizer/vim.png"
      },
      

    ]
  }
  ,
  {
    category: "Financial Sectors",
    images: "../partnership/financelogo.png",
    partners: [
      {
        "image_src": "../partnership/finance/brics.jpg"
      },
      {
        "image_src": "../partnership/finance/ebcc.jpg"
      },
      {
        "image_src": "../partnership/finance/komutet.png"
      },
      

    ]
  },

]


export const partners = [
  {
    category: "Technology (IT)",
    partners: [
      {
        image_src: "../partnership/IT/fortecom.png",
        description: "Fortecom Solutions"
      },
      {
        image_src: "../partnership/IT/kaspersky.png",
        description: "Kaspersky Security"
      },
      {
        image_src: "../partnership/IT/softclub.png",
        description: "SoftClub Systems"
      },
      {
        image_src: "../partnership/IT/mpplabs.jpg",
        description: "MPP Labs"
      },
      {
        image_src: "../partnership/IT/sap.jpg",
        description: "SAP Solutions"
      },
      {
        image_src: "../partnership/IT/softline.png",
        description: "SoftLine Technologies"
      },
      {
        image_src: "../partnership/IT/gs.png",
        description: "GS Innovations"
      },
    ]
  }
];